// extracted by mini-css-extract-plugin
export default {"icon":"ContactUs_icon__Yjd67","link":"ContactUs_link__rpyqp"};